import { ref, computed, onMounted, onUnmounted } from 'vue';

// Debounce utility
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
export const useResponsiveScreen = (options = {}) => {
  const {
    mobileBreakpoint = 768,
    desktopBreakpoint = 1482,
    heightBreakpoint = 897,
    debounceMs = 100
  } = options;
  const screenWidth = ref(window?.innerWidth || 1024);
  const screenHeight = ref(window?.innerHeight || 768);
  const debouncedResize = debounce(() => {
    screenWidth.value = window.innerWidth;
    screenHeight.value = window.innerHeight;
  }, debounceMs);
  const isSmallScreen = computed(() => {
    return screenWidth.value < mobileBreakpoint;
  });
  const isPanelAwareSmallScreen = (leftPanelOpen, rightPanelOpen) => {
    const bothPanelsOpen = leftPanelOpen && rightPanelOpen;
    const viewportTooSmall = screenWidth.value < desktopBreakpoint || screenHeight.value < heightBreakpoint;
    return screenWidth.value < mobileBreakpoint || bothPanelsOpen && viewportTooSmall;
  };
  onMounted(() => {
    window.addEventListener('resize', debouncedResize);
  });
  onUnmounted(() => {
    window.removeEventListener('resize', debouncedResize);
  });
  return {
    screenWidth,
    screenHeight,
    isSmallScreen,
    isPanelAwareSmallScreen
  };
};